import DatePicker from 'react-datepicker';
import { CalendarDays, X } from 'lucide-react';

type Props = {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (dates: [Date | null, Date | null]) => void;
  error?: string;
};

export default function DateRangeFilter({ startDate, endDate, onChange, error }: Props) {
  const showClear = startDate || endDate;

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Date Range</label>

      <div className="relative w-fit">
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={onChange}
          maxDate={new Date()}
          dateFormat="dd/MM/yy"
          placeholderText="Start Date - End Date"
          calendarStartDay={0}
          popperClassName="datepicker-popper"
          popperPlacement="bottom-start"
          wrapperClassName="cursor-pointer"
          className="
            border border-[#001B6B]
            rounded-lg
            px-9 pr-10
            py-2
            w-[210px]
            bg-transparent
            outline-none
            cursor-pointer
            text-sm
          "
        />

        {/* Calendar Icon */}
        <CalendarDays
          size={18}
          className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none text-sm"
        />

        {showClear && (
          <button
            type="button"
            onClick={() => onChange([null, null])}
            className="
              absolute right-3 top-1/2 -translate-y-1/2
              text-blue-500 hover:text-blue-900
            "
          >
            <X size={16} />
          </button>
        )}
      </div>

      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
